<template>
  <div class="container-fluid">
    <div class="panel panel-info">

      <!-- <div  class="p-3 mb-2 bg-secondary text-white">
        <b style="text-align: left">Clinic Near By :</b>

        
            <b-button class="float-right"  variant="primary" @click="handleBack">Back</b-button>
        
      </div> --> 
      <div class="p-3 mb-2 col-12">
    <h5>Clinic Near By:
     <b-btn
          class="btn-danger float-right"
           style="text-align: right;"
          @click="handleBack()"
        >
         <b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill> Back
        </b-btn></h5>
      </div>
      <hr>
      <div class="panel-body">
        <div>
          <div class="md-4">
            <!-- <p class="right" style="text-align: right">delete</p> -->
            <i class="fa fa-trash-o" style="font-size: 36px"></i>
        <b-card
              img-src="https://joeschmoe.io/api/v1/3"
              img-alt="Card image"
              img-left
              class="mb-3"
              style="height: 110px"
            >
              <!-- <b-card
            class='fas fa-map-marker-alt'
            > -->
              <b-card-text class="mycard">
                <table style="line-height: 1">
                  <tr>
                    <td width="45%" style="text-align: left">Doctor Name</td>
                    <td width="1%" style="text-align: left">:</td>
                    <td width="54%" style="text-align: left">Dr M.S Patil</td>
                    <!-- <td>
                      <b-button
                        type="button"
                        size="sm"
                        variant="primary"
                        style="float: right"
                        class="fa fa-eye"
                        
                      >
                        <router-link
                          style="color: white"
                          :to="{ name: 'medical' }"
                          >Remove</router-link
                        >
                      </b-button> 
                      
                    </td> -->
                  </tr>
                  <tr>
                    <td width="45%" style="text-align: left">Degree</td>
                    <td width="1%" style="text-align: left">:</td>
                    <td width="54%" style="text-align: left">B.V.Sc</td>
                  </tr>
                  <!-- <tr>
                    <td width="45%" style="text-align:left">Animal Type</td>
                    <td width="1%" style="text-align:left">:</td>
                    <td width="54%" style="text-align:left">**</td>
                  </tr> -->
                  <tr>
                    <td width="45%" style="text-align: left">Experience</td>
                    <td width="1%" style="text-align: left">:</td>
                    <td width="54%" style="text-align: left">10 Years</td>
                  </tr>
                  <tr>
                    <td width="45%" style="text-align: left">Clinic</td>
                    <td width="1%" style="text-align: left">:</td>
                    <td width="54%" style="text-align: left">S. V. Hospital</td>
                  </tr>
                </table>
              </b-card-text>
            </b-card>
          </div>
         
         
          <!-- <b-button style="float: left" variant="danger" @click="handleBack">Back</b-button> -->
          <!-- <b-button  variant="danger" @click="handleBack">Back</b-button> -->
          
        </div>
        <div>
          <div class="md-4">
            <!-- <p class="right" style="text-align: right">delete</p> -->
            <i class="fa fa-trash-o" style="font-size: 36px"></i>
        <b-card
              img-src="https://joeschmoe.io/api/v1/2"
              img-alt="Card image"
              img-left
              class="mb-3"
              style="height: 110px"
            >


              <!-- <b-card
            class='fas fa-map-marker-alt'
            > -->
              <b-card-text class="mycard">
                <table style="line-height: 1">
                  <tr>
                    <td width="45%" style="text-align: left">Doctor Name</td>
                    <td width="1%" style="text-align: left">:</td>
                    <td width="54%" style="text-align: left">Dr R.S Sharma</td>
                    <!-- <td>
                      <b-button
                        type="button"
                        size="sm"
                        variant="primary"
                        style="float: right"
                        class="fa fa-eye"
                        
                      >
                        <router-link
                          style="color: white"
                          :to="{ name: 'medical' }"
                          >Remove</router-link
                        >
                      </b-button> 
                      
                    </td> -->
                  </tr>
                  <tr>
                    <td width="45%" style="text-align: left">Degree</td>
                    <td width="1%" style="text-align: left">:</td>
                    <td width="54%" style="text-align: left">B.V.Sc</td>
                  </tr>
                  <!-- <tr>
                    <td width="45%" style="text-align:left">Animal Type</td>
                    <td width="1%" style="text-align:left">:</td>
                    <td width="54%" style="text-align:left">**</td>
                  </tr> -->
                  <tr>
                    <td width="45%" style="text-align: left">Experience</td>
                    <td width="1%" style="text-align: left">:</td>
                    <td width="54%" style="text-align: left">15 Years</td>
                  </tr>
                  <tr>
                    <td width="45%" style="text-align: left">Clinic</td>
                    <td width="1%" style="text-align: left">:</td>
                    <td width="54%" style="text-align: left">S. V. Hospital</td>
                  </tr>
                </table>
              </b-card-text>
            </b-card>
          </div>
         
         
          <!-- <b-button style="float: left" variant="danger" @click="handleBack">Back</b-button> -->
          <!-- <b-button  variant="danger" @click="handleBack">Back</b-button> -->
          
        </div>
        <div>
          <div class="md-4">
            <!-- <p class="right" style="text-align: right">delete</p> -->
            <i class="fa fa-trash-o" style="font-size: 36px"></i>
            <b-card
              img-src="https://joeschmoe.io/api/v1/random"
              img-alt="Card image"
              img-left
              class="mb-3"
              style="height: 110px"
            >
              <!-- <b-card
            class='fas fa-map-marker-alt'
            > -->
              <b-card-text class="mycard">
                <table style="line-height: 1">
                  <tr>
                    <td width="45%" style="text-align: left">Doctor Name</td>
                    <td width="1%" style="text-align: left">:</td>
                    <td width="54%" style="text-align: left">Dr S.S.Gurav </td>
                    <!-- <td>
                      <b-button
                        type="button"
                        size="sm"
                        variant="primary"
                        style="float: right"
                        class="fa fa-eye"
                        
                      >
                        <router-link
                          style="color: white"
                          :to="{ name: 'medical' }"
                          >Remove</router-link
                        >
                      </b-button> 
                      
                    </td> -->
                  </tr>
                  <tr>
                    <td width="45%" style="text-align: left">Degree</td>
                    <td width="1%" style="text-align: left">:</td>
                    <td width="54%" style="text-align: left">B.V.Sc</td>
                  </tr>
                  <!-- <tr>
                    <td width="45%" style="text-align:left">Animal Type</td>
                    <td width="1%" style="text-align:left">:</td>
                    <td width="54%" style="text-align:left">**</td>
                  </tr> -->
                  <tr>
                    <td width="45%" style="text-align: left">Experience</td>
                    <td width="1%" style="text-align: left">:</td>
                    <td width="54%" style="text-align: left">10 Years</td>
                  </tr>
                  <tr>
                    <td width="45%" style="text-align: left">Clinic</td>
                    <td width="1%" style="text-align: left">:</td>
                    <td width="54%" style="text-align: left">S. V. Hospital</td>
                  </tr>
                </table>
              </b-card-text>
            </b-card>
          </div>
         
         
          <!-- <b-button style="float: left" variant="danger" @click="handleBack">Back</b-button> -->
          <!-- <b-button  variant="danger" @click="handleBack">Back</b-button> -->
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import * as _ from "lodash";

//import ApplicationFilter from "../components/ApplicationFilter.vue";
//import MarksEntry from "../components/MarksEntry.vue";
//alert(1);
export default {
  methods: {
    handleBack(){
            this.$router.go(-1);
        },
  },

};
</script>

<style>
table {
  font-family: arial, sans-serif;
  line-height: 1;
  width: 100%;
}

td,
th {
  border: 0px solid #dddddd;
  text-align: left;
  padding: 2px;
}
.mycard {
  padding-top: 5px !important;
  padding-bottom: 5px;
}
body {
  line-height: 1;
}
</style>

